import { useState } from "react";
import axios from "axios";
import { Send, CheckCircle2 } from "lucide-react";
import { Reveal } from "@/components/Reveal";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const inputCls =
  "w-full bg-[#0A0A0A] border border-white/10 px-5 py-4 font-mono-p text-sm text-[#F5F5F5] placeholder:text-[#A1A1AA]/60 focus:border-[#0055FF] focus:outline-none transition-colors duration-300";

const ContactForm = () => {
  const [form, setForm] = useState({ name: "", email: "", message: "" });
  const [status, setStatus] = useState("idle");
  const [error, setError] = useState("");

  const submit = async (e) => {
    e.preventDefault();
    setStatus("sending");
    setError("");
    try {
      await axios.post(`${API}/enquiries`, form);
      setStatus("sent");
    } catch (err) {
      setStatus("idle");
      setError("Something went wrong — please call us at +1 888-499-9335 instead.");
    }
  };

  if (status === "sent") {
    return (
      <Reveal>
        <div
          data-testid="contact-form-success"
          className="border border-[#0055FF]/40 bg-[#0055FF]/5 p-10 md:p-12 flex items-start gap-5"
        >
          <CheckCircle2 className="w-6 h-6 text-[#0055FF] shrink-0 mt-1" />
          <div>
            <h3 className="font-oswald text-xl tracking-[0.1em] uppercase mb-3">Message received</h3>
            <p className="font-mono-p text-sm leading-relaxed text-[#A1A1AA]">
              Thanks, {form.name.split(" ")[0] || "reader"} — your enquiry is with the editorial desk.
              We reply within 2–3 business days. Need us sooner? Call +1 888-499-9335.
            </p>
          </div>
        </div>
      </Reveal>
    );
  }

  return (
    <Reveal>
      <form onSubmit={submit} data-testid="contact-form" className="border border-white/10 bg-[#121212]/40 p-8 md:p-10">
        <p className="font-mono-p text-[10px] tracking-[0.3em] uppercase text-[#A1A1AA] mb-8">
          No phone, no email app? Write to us right here.
        </p>
        <div className="grid md:grid-cols-2 gap-4 mb-4">
          <input
            required
            data-testid="contact-form-name-input"
            placeholder="Your name"
            value={form.name}
            onChange={(e) => setForm({ ...form, name: e.target.value })}
            className={inputCls}
          />
          <input
            required
            type="email"
            data-testid="contact-form-email-input"
            placeholder="Your email"
            value={form.email}
            onChange={(e) => setForm({ ...form, email: e.target.value })}
            className={inputCls}
          />
        </div>
        <textarea
          required
          rows={5}
          data-testid="contact-form-message-input"
          placeholder="Your question, correction, or comparison request…"
          value={form.message}
          onChange={(e) => setForm({ ...form, message: e.target.value })}
          className={`${inputCls} resize-none mb-6`}
        />
        {error && (
          <p data-testid="contact-form-error" className="font-mono-p text-xs text-[#FF3300] mb-4">{error}</p>
        )}
        <button
          type="submit"
          disabled={status === "sending"}
          data-testid="contact-form-submit-button"
          className="flex items-center gap-3 font-oswald text-sm tracking-[0.25em] uppercase bg-[#F5F5F5] text-[#0A0A0A] px-8 py-4 hover:bg-[#0055FF] hover:text-white transition-colors duration-300 disabled:opacity-50"
        >
          <Send className="w-4 h-4" /> {status === "sending" ? "Sending…" : "Send enquiry"}
        </button>
      </form>
    </Reveal>
  );
};

export default ContactForm;
